var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "detailForm",
          staticClass: "demo-detailForm",
          attrs: {
            model: _vm.detailForm,
            rules: _vm.rules,
            "label-width": "100px",
          },
        },
        [
          _c("el-form-item", { attrs: { label: "版本", prop: "version" } }, [
            _c("span", [_vm._v(_vm._s(_vm.version))]),
          ]),
          _c(
            "el-form-item",
            { attrs: { label: "所属大类" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    disabled: _vm.statusView != "C" ? false : true,
                    placeholder: "请选择所属大类",
                  },
                  model: {
                    value: _vm.detailForm.parentId,
                    callback: function ($$v) {
                      _vm.$set(_vm.detailForm, "parentId", $$v)
                    },
                    expression: "detailForm.parentId",
                  },
                },
                _vm._l(_vm.parentList, function (v, i) {
                  return _c("el-option", {
                    key: i,
                    attrs: { label: v.name, value: v.code },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "评分项名称", prop: "name" } },
            [
              _c("el-input", {
                attrs: { disabled: _vm.statusView != "C" ? false : true },
                model: {
                  value: _vm.detailForm.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.detailForm, "name", $$v)
                  },
                  expression: "detailForm.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "SPM", prop: "version" } },
            [
              _c("el-input", {
                attrs: { disabled: _vm.statusView != "C" ? false : true },
                model: {
                  value: _vm.detailForm.version,
                  callback: function ($$v) {
                    _vm.$set(_vm.detailForm, "version", $$v)
                  },
                  expression: "detailForm.version",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Wt.1", prop: "wt1" } },
            [
              _c("el-input", {
                attrs: { disabled: _vm.statusView != "C" ? false : true },
                on: {
                  input: function ($event) {
                    _vm.detailForm.wt1 = _vm.detailForm.wt1.replace(
                      /[^\d.]/g,
                      ""
                    )
                  },
                },
                model: {
                  value: _vm.detailForm.wt1,
                  callback: function ($$v) {
                    _vm.$set(_vm.detailForm, "wt1", $$v)
                  },
                  expression: "detailForm.wt1",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Wt.2" } },
            [
              _c("el-input", {
                attrs: { disabled: _vm.statusView != "C" ? false : true },
                on: {
                  input: function ($event) {
                    _vm.detailForm.wt2 = _vm.detailForm.wt2.replace(
                      /[^\d.]/g,
                      ""
                    )
                  },
                },
                model: {
                  value: _vm.detailForm.wt2,
                  callback: function ($$v) {
                    _vm.$set(_vm.detailForm, "wt2", $$v)
                  },
                  expression: "detailForm.wt2",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "最大分值", prop: "maxValue" } },
            [
              _c("el-input", {
                attrs: { disabled: _vm.statusView != "C" ? false : true },
                on: {
                  input: function ($event) {
                    _vm.detailForm.maxValue = _vm.detailForm.maxValue.replace(
                      /[^\d.]/g,
                      ""
                    )
                  },
                },
                model: {
                  value: _vm.detailForm.maxValue,
                  callback: function ($$v) {
                    _vm.$set(_vm.detailForm, "maxValue", $$v)
                  },
                  expression: "detailForm.maxValue",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Description", prop: "description" } },
            [
              _c("el-input", {
                attrs: {
                  disabled: _vm.statusView != "C" ? false : true,
                  type: "textarea",
                  rows: 2,
                  placeholder: "请输入内容",
                },
                model: {
                  value: _vm.detailForm.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.detailForm, "description", $$v)
                  },
                  expression: "detailForm.description",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "评分标准说明1", prop: "standard1" } },
            [
              _c("el-input", {
                attrs: {
                  disabled: _vm.statusView != "C" ? false : true,
                  type: "textarea",
                  rows: 2,
                  placeholder: "请输入内容",
                },
                model: {
                  value: _vm.detailForm.standard1,
                  callback: function ($$v) {
                    _vm.$set(_vm.detailForm, "standard1", $$v)
                  },
                  expression: "detailForm.standard1",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "评分标准说明2", prop: "standard2" } },
            [
              _c("el-input", {
                attrs: {
                  disabled: _vm.statusView != "C" ? false : true,
                  type: "textarea",
                  rows: 2,
                  placeholder: "请输入内容",
                },
                model: {
                  value: _vm.detailForm.standard2,
                  callback: function ($$v) {
                    _vm.$set(_vm.detailForm, "standard2", $$v)
                  },
                  expression: "detailForm.standard2",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "评分标准说明3", prop: "standard3" } },
            [
              _c("el-input", {
                attrs: {
                  disabled: _vm.statusView != "C" ? false : true,
                  type: "textarea",
                  rows: 2,
                  placeholder: "请输入内容",
                },
                model: {
                  value: _vm.detailForm.standard3,
                  callback: function ($$v) {
                    _vm.$set(_vm.detailForm, "standard3", $$v)
                  },
                  expression: "detailForm.standard3",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "评分标准说明4", prop: "standard4" } },
            [
              _c("el-input", {
                attrs: {
                  disabled: _vm.statusView != "C" ? false : true,
                  type: "textarea",
                  rows: 2,
                  placeholder: "请输入内容",
                },
                model: {
                  value: _vm.detailForm.standard4,
                  callback: function ($$v) {
                    _vm.$set(_vm.detailForm, "standard4", $$v)
                  },
                  expression: "detailForm.standard4",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "评分标准说明5", prop: "standard5" } },
            [
              _c("el-input", {
                attrs: {
                  disabled: _vm.statusView != "C" ? false : true,
                  type: "textarea",
                  rows: 2,
                  placeholder: "请输入内容",
                },
                model: {
                  value: _vm.detailForm.standard5,
                  callback: function ($$v) {
                    _vm.$set(_vm.detailForm, "standard5", $$v)
                  },
                  expression: "detailForm.standard5",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "排序", prop: "orderNo" } },
            [
              _c("el-input", {
                attrs: { disabled: _vm.statusView != "C" ? false : true },
                on: {
                  input: function ($event) {
                    _vm.detailForm.orderNo = _vm.detailForm.orderNo.replace(
                      /[^\d.]/g,
                      ""
                    )
                  },
                },
                model: {
                  value: _vm.detailForm.orderNo,
                  callback: function ($$v) {
                    _vm.$set(_vm.detailForm, "orderNo", $$v)
                  },
                  expression: "detailForm.orderNo",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.statusView != "C"
        ? _c(
            "el-row",
            { attrs: { type: "flex", justify: "center" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.onSave("detailForm")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }